import React, { FC } from 'react';

import { Layout } from '@/shared/ui';
import { UserSuppliesSection } from '@/features/Pools/ui/UserSupplySection/ui';
import { GuideInfo } from '@/widgets/GuideInfo';
import { SegmentButtonGroup } from '@/widgets/SegmentButtonGroup';
import { Faqs } from '@/widgets/FAQs';
import { AssetsToLendSection } from '@/features/Pools';

export const Leverage: FC = () => {
    return (
        <div>
            <Layout isBorder>
                <GuideInfo />
                <SegmentButtonGroup />
            </Layout>
            <Layout>
                <UserSuppliesSection />
                <AssetsToLendSection />
            </Layout>
            <Faqs />
        </div>
    );
};
